import React, { ReactElement } from 'react'
import Icon from '@dustin-web/microsite-components/src/icon'
import { icons } from '@dustin-web/microsite-components/src/icon/icons'
import { useTranslations } from '@dustin-web/microsite-components/src/hooks'
import classnames from 'classnames'
export type IconName = keyof typeof icons

type DropdownItemProps = {
  linkHref?: string
  linkID?: string
  linkRel?: string
  linkOnClick?: (e: any) => void
  hasArrowIcon?: boolean
  quantity?: number
  title?: string
  iconName?: IconName
  customerNumber?: string
  companyName?: string
  userName?: string
}

export const DropdownItem = ({
  linkID,
  linkRel,
  linkHref,
  linkOnClick,
  hasArrowIcon = false,
  quantity,
  title,
  iconName,
  customerNumber,
  companyName,
  userName,
}: DropdownItemProps) => {
  const { translate } = useTranslations()
  return (
    <li
      className={classnames('c-header__dropdown-item', {
        'c-header__dropdown-item_bordered': customerNumber || companyName || userName,
      })}>
      {title && (
        <a
          id={linkID}
          className="c-header__dropdown-link"
          rel={linkRel}
          href={linkHref}
          onClick={linkOnClick}>
          {iconName && <Icon name={iconName} className="i-20 u-mr-8" />}
          {title && <span className="c-header__dropdown-text">{title}</span>}
          {quantity && <span className="u-mr-4">{`(${quantity})`}</span>}
          {hasArrowIcon && (
            <Icon name="arrow-right-small" className="c-header__dropdown-icon i-20" />
          )}
        </a>
      )}
      {customerNumber && (
        <div className="d-flex flex-column">
          <span className="c-header__dropdown-text c-header__dropdown-text_bold">
            {translate('UserAccount_CustomerId')}:
          </span>
          <span> {customerNumber}</span>
        </div>
      )}
      {userName && (
        <div className="d-flex flex-column">
          <span className="c-header__dropdown-text c-header__dropdown-text_bold">
            {translate('AccountMenu_Name')}:
          </span>
          <span className="c-header__dropdown-text"> {userName}</span>
        </div>
      )}
      {companyName && (
        <div className="d-flex flex-column">
          <span className="c-header__dropdown-text c-header__dropdown-text_bold">
            {translate('AccountMenu_Impersonate')}:
          </span>
          <span className="c-header__dropdown-text"> {companyName}</span>
        </div>
      )}
    </li>
  )
}

export const DropdownList = ({ children }: { children: ReactElement | ReactElement[] }) => (
  <ul className="c-header__dropdown-menu">{children}</ul>
)
